(function(angular, schoolwork12) {
	'use strict';
	
	schoolwork12.app.submission = {
        name: 'schoolwork12.submission',
        controllers: {
            submissionLogs : 'submissionLogsCtrl'
        },
        routes: {
            submissionLogs: '/submission-log'
        },
        templates : {
            submissionLogs: 'submissionLogs/html/viewSubmissionLogs.html'
        },
        services: {
            submissionLogsSvc: 'submissionLogsSvc'        
        },
        endpoints: {
            getSubmissionsLogsEndpoint: schoolwork12.app.endpoint.concat('/log/type/')
        }
	};
	
	angular.module(schoolwork12.app.submission.name, []);
     
}(angular, schoolwork12));
